import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './SeatingChartSelectionBar.scss';

const SeatingChartSelectionBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="selection-bar">
      <div className="container">
        <div>
          <span className="hide-mobile">
            {t(
              props.selectedSeatsLabel
                ? props.selectedSeatsLabel
                : 'seatingChart.countSeatsSelected',
              { count: props.count, total: props.total }
            )}
          </span>
          <span className="show-mobile">
            {t('seatingChart.countSeatsSelectedMobile', { count: props.count, total: props.total })}
          </span>
        </div>
        <div>
          <button className="btn btn-outline hide-mobile" onClick={props.handleBack}>
            {t('common.labels.back')}
          </button>
          <button
            className="btn btn-primary hide-mobile"
            onClick={props.handleSave}
            disabled={props.isButtonDisabled}>
            {t(props.saveBtnLabel ? props.saveBtnLabel : 'common.labels.save')}
          </button>

          <button className="btn btn-small btn-outline show-mobile" onClick={props.handleBack}>
            {t('common.labels.back')}
          </button>
          <button className="btn btn-small btn-primary show-mobile" onClick={props.handleSave}>
            {t('common.labels.save')}
          </button>
        </div>
      </div>
    </div>
  );
};

SeatingChartSelectionBar.propTypes = {
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  saveBtnLabel: PropTypes.string,
  selectedSeatsLabel: PropTypes.string,
  handleSave: PropTypes.func,
  handleBack: PropTypes.func,
};

export default SeatingChartSelectionBar;
